import { devLog } from '../utils/devLog';
import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getRoles, sortJobsByStatus } from '../utils/api';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const [cvs, setCVs] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isLoadingJobs, setIsLoadingJobs] = useState(true);

  const loadJobs = useCallback(async (statusFilter = null) => {
    setIsLoadingJobs(true);
    try {
      const result = await getRoles(statusFilter);
      if (result.success) {
        setJobs(result.data.roles);
      }
    } catch (error) {
      devLog.error('Error loading jobs:', error);
    } finally {
      setIsLoadingJobs(false);
    }
  }, []);

  // Fetch jobs on mount
  useEffect(() => {
    loadJobs();
  }, [loadJobs]);

  const addJob = (job) => {
    setJobs(prev => {
      const newJobs = [job, ...prev];
      // Sort to maintain Open > On Hold > Closed order
      return sortJobsByStatus(newJobs);
    });
  };

  const updateJob = (jobId, updatedData) => {
    setJobs(prev => {
      const updated = prev.map(job => 
        job.id === jobId ? { ...job, ...updatedData } : job
      );
      // Re-sort after update to maintain order
      return sortJobsByStatus(updated);
    });
  };

  const deleteJob = (jobId) => {
    setJobs(prev => prev.filter(job => job.id !== jobId));
  };

  const addCV = (cv) => {
    setCVs(prev => [...prev, cv]);
  };

  const deleteCV = (cvId) => {
    setCVs(prev => prev.filter(cv => cv.id !== cvId));
  };

  const addQuestion = (question) => {
    setQuestions(prev => [...prev, question]);
  };

  const deleteQuestion = (questionId) => {
    setQuestions(prev => prev.filter(question => question.id !== questionId));
  };

  const value = {
    jobs,
    cvs,
    questions,
    isLoadingJobs,
    addJob,
    updateJob,
    deleteJob,
    loadJobs,
    addCV,
    deleteCV,
    addQuestion,
    deleteQuestion
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};
